import {
  GenericSuggestion,
  SuggestionPipelines,
} from 'types/suggestions/CoreSuggestions';
import { SuggestionStatus } from 'types/suggestions/LoadSuggestions';

export type KitPipelineCounts = Partial<Record<SuggestionPipelines, number>>;

// Total suggestions per pipeline (including Accepted).
export function countByPipeline(
  grouped: Partial<Record<SuggestionPipelines, GenericSuggestion[]>>
): KitPipelineCounts {
  const counts: KitPipelineCounts = {};
  for (const [pipeline, suggestions] of Object.entries(grouped) as [
    SuggestionPipelines,
    GenericSuggestion[] | undefined,
  ][]) {
    if (!suggestions?.length) {
      continue;
    }
    counts[pipeline] = suggestions.length;
  }
  return counts;
}

// Pending (non-Accepted) suggestions per pipeline from a grouped map.
export function countPendingByPipeline(
  grouped: Partial<Record<SuggestionPipelines, GenericSuggestion[]>>
): KitPipelineCounts {
  const counts: KitPipelineCounts = {};
  for (const [pipeline, suggestions] of Object.entries(grouped) as [
    SuggestionPipelines,
    GenericSuggestion[] | undefined,
  ][]) {
    if (!suggestions?.length) {
      continue;
    }
    const pending = suggestions.filter(
      (s) => s.status !== SuggestionStatus.Accepted
    ).length;
    if (pending > 0) {
      counts[pipeline] = pending;
    }
  }
  return counts;
}

// Pending counts from a flat suggestion list (auto-collapse effect).
export function countPendingFromList(
  suggestions: GenericSuggestion[]
): KitPipelineCounts {
  const counts: KitPipelineCounts = {};
  for (const suggestion of suggestions) {
    if (suggestion.status === SuggestionStatus.Accepted) {
      continue;
    }
    counts[suggestion.pipeline] = (counts[suggestion.pipeline] ?? 0) + 1;
  }
  return counts;
}

export function sumPipelineCounts(
  counts: KitPipelineCounts,
  pipelines: SuggestionPipelines[]
): number {
  return pipelines.reduce((n, pipeline) => n + (counts[pipeline] ?? 0), 0);
}
